<template>
  <mdbCard v-if="documentos.length" class="mb-3 card-bordered">
    <mdbCardBody>
      <mdbCardTitle class="mb-2">
        <font-awesome-icon icon="file-pdf" class="mr-2 text-muted" />
        Documento adjunto
      </mdbCardTitle>
      <div
        v-for="(documento, i) in documentos"
        :key="documento.ruta || i"
        class="mb-2"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span class="font-weight-medium">{{ documento.nom }}</span>
          <div class="flex-shrink-0 ml-3">
            <mdbBtn
              v-if="previsualizable(documento)"
              size="sm"
              flat
              dark-waves
              icon="eye"
              class="m-0 px-2 py-2"
              @click="alternar(i)"
            >
              {{ previewActivo === i ? 'Ocultar' : 'Vista previa' }}
            </mdbBtn>
            <mdbBtn
              size="sm"
              flat
              dark-waves
              icon="external-link-alt"
              class="m-0 px-2 py-2"
              @click="abrir(documento)"
            >
              Abrir
            </mdbBtn>
          </div>
        </div>
        <iframe
          v-if="previewActivo === i && previsualizable(documento)"
          :src="rutaCompleta(documento)"
          class="documento-vista-previa"
        />
      </div>
    </mdbCardBody>
  </mdbCard>
</template>

<script>
import {mdbCard, mdbCardTitle, mdbCardBody, mdbBtn} from 'mdbvue';
import {filesURL} from '@/funciones/api.js';

export default {
  name: 'DocumentoAdjunto',
  components: {
    mdbCard,
    mdbCardTitle,
    mdbCardBody,
    mdbBtn,
  },
  props: {
    documentos: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      previewActivo: -1,
    };
  },
  methods: {
    rutaCompleta(documento) {
      return `${filesURL}/${documento.ruta}`;
    },
    previsualizable(documento) {
      return /\.(pdf|jpe?g|png|gif|webp)$/i.test(documento.nom || documento.ruta || '');
    },
    alternar(indice) {
      this.previewActivo = this.previewActivo === indice ? -1 : indice;
    },
    abrir(documento) {
      window.open(this.rutaCompleta(documento), '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
  .documento-vista-previa {
    border: 1px solid $gris-tr-borde;
    height: 400px;
    width: 100%;
  }
</style>
